import { ReactNode } from "react";
import { TKey } from "@/app/translations/TKey";

export type ToolItemType = {
  id: string;
  title: TKey;
  desc: TKey;
  icon: ReactNode;
  available: boolean;
  href: string;
  highlighted?: boolean;
};

export type ToolPhaseType = {
  phaseTitle: TKey;
  tools: ToolItemType[];
};

export type ToolCheck = {
  title: TKey;
  text: TKey;
};

export type ToolsKeys = {
  supTitle: TKey;
  title: TKey;
  introText: TKey;
  checks: ToolCheck[];
  flagship: TKey;
  upcoming: TKey;
  btnAccess: TKey;
  btnNotify: TKey;
};

export enum ToolGroupId {
  AVAILABLE = "available",
  UPCOMING = "upcoming",
}

export type ToolGroup = {
  id: ToolGroupId;
  label?: TKey;
  tools: ToolItemType[];
};
